import React from "react";
import "./Layout.css";
import { Toaster } from "../ui/toaster";

const CkLayout = ({ children }) => {
    return (
        <div className="App">
            {children}
            <Toaster />
        </div>
    );
};

export default CkLayout;